export function formatNumber(value: number): string {
    return value.toLocaleString();
}

export function formatViewCount(count: number | null | undefined): string {
  if (count == null || isNaN(count)) return '♡';
  
  if (count >= 10000) {
    return `${(count / 10000).toFixed(1)}万`;
  }
  return count.toLocaleString();
}